/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Request_To_Speak_HintInputs */



/**
* | output |
* | --- |
* | "Allow requests to speak in Stage channels. Stage moderators manually approve or deny each request." |
*
* @param {Leveling_Perm_Request_To_Speak_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_request_to_speak_hint = /** @type {((inputs?: Leveling_Perm_Request_To_Speak_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Request_To_Speak_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрешает просить слова на трибунах. Модераторы трибуны вручную одобряют или отклоняют каждый запрос.")
	return /** @type {LocalizedString} */ ("Allow requests to speak in Stage channels. Stage moderators manually approve or deny each request.")
});